import { PulseStorage } from '@pulse/common';
import { Observable, ReplaySubject } from 'rxjs';

export abstract class QueryParamsService {
    private value: string | null = null;
    private valueSubject$ = new ReplaySubject<string | null>(1);

    constructor(
        protected readonly pulseStorage: PulseStorage,
        protected readonly cookieStorage: PulseStorage,
        protected readonly STORAGE_KEY: string,
    ) {
        this.subscribeToChanges();
        //TODO: remove after 2 moths of the release
        this.cookieStorage.remove(this.STORAGE_KEY);
    }

    private subscribeToChanges(): void {
        this.pulseStorage.change(this.STORAGE_KEY).subscribe((change) => {
            this.setValue(change.value);
        });
    }

    private setValue(newValue: string | null): void {
        if (newValue === this.value) {
            return;
        }

        this.value = newValue;
        this.valueSubject$.next(newValue);
    }

    getValue(): string | null {
        return this.value;
    }

    getValue$(): Observable<string | null> {
        return this.valueSubject$.asObservable();
    }

    setFromQueryParams() {
        let newValue = this.pulseStorage.get(this.STORAGE_KEY);

        /*
         * Check value in storage
         * Storage have higher priority
         * If value not exist in storage then get from url
         * */
        if (newValue === null) {
            if (document?.currentScript instanceof HTMLScriptElement) {
                const parentScriptPathQuerys = new URLSearchParams(document?.currentScript.src);
                newValue = parentScriptPathQuerys.get(this.STORAGE_KEY);
            }
        }

        this.setValue(newValue);
    }
}
